<div class="cp-wrap">
  <form class="cp-card" (ngSubmit)="submit()">
    <h2>{{ forced ? 'Set your own password' : 'Change password' }}</h2>
    @if (forced) {
      <p class="cp-note">An Admin reset your password and gave you a temporary one. Enter it below, then choose your own. You cannot use Link until this is done.</p>
    }
    <label>{{ forced ? 'Temporary password' : 'Current password' }}<input type="password" [(ngModel)]="current" name="current" autocomplete="current-password" required /></label>
    <label>New password<input type="password" [(ngModel)]="next" name="next" autocomplete="new-password" minlength="8" required /></label>
    <label>New password again<input type="password" [(ngModel)]="confirm" name="confirm" autocomplete="new-password" required /></label>
    @if (error) { <div class="cp-error">{{ error }}</div> }
    <button type="submit" [disabled]="busy">{{ busy ? 'Saving…' : 'Save password' }}</button>
    <small>Signed in as {{ userName }}. At least 8 characters.</small>
  </form>
</div>
